export default __webpack_public_path__ + "static/media/nodejs-icon.502737ea.svg";